import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { AuthenticationService } from '../services/authentication.service';
import { Observable } from 'rxjs';

@Injectable()

export class JwtInterceptor implements HttpInterceptor {

    constructor(private authenticationService: AuthenticationService){}
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
        const currentToken = this.authenticationService.currentTokenValue;
        if(currentToken){
            request = request.clone({
                setHeaders:{
                    Authorization: `Bearer ${currentToken}`
                }
                
            });
        }
        
    return next.handle(request)

    }

}